import MultipleFooter from './MultipleFooter'

export default MultipleFooter;